export const author = {
    name: 'Kyle Rich'
};
